import { Reducer, Action } from "redux";
import { IAlertMessageBannerState, KnownAction, GET_BANNER_ALERT_MESSAGE, LOADER_FOR_BANNER_ALERT_MESSAGE, RESET_FOR_BANNER_ALERT_MESSAGE } from "./types";

export const reducer: Reducer<IAlertMessageBannerState> = (state: IAlertMessageBannerState | undefined, incomingAction: Action): IAlertMessageBannerState => {
    if (state === undefined) {
        return { alertMessageBanner: [], isLoadingBannerMessage: false };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case GET_BANNER_ALERT_MESSAGE:
            return {
                ...state,
                alertMessageBanner: action.alertMessageBanner,
            };
        case LOADER_FOR_BANNER_ALERT_MESSAGE:
            return {
                ...state,
                isLoadingBannerMessage: action.isLoadingBannerMessage,
            };
        case RESET_FOR_BANNER_ALERT_MESSAGE:
            return {
                ...state,
                isLoadingBannerMessage: false,
                alertMessageBanner: [],
            };
        default:
            return state;
    }
};
